import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle, FiClock, FiShield, FiTarget } from 'react-icons/fi';

const QuizCTASection = () => {
  const benefits = [
    {
      icon: FiTarget,
      title: "Identify Specific Challenges",
      description: "Pinpoint your child's unique learning profile"
    },
    {
      icon: FiCheckCircle,
      title: "Personalized Recommendations",
      description: "Get targeted strategies for your child's needs"
    },
    {
      icon: FiClock,
      title: "Takes Just 5 Minutes",
      description: "Quick assessment with immediate insights"
    },
    {
      icon: FiShield,
      title: "Completely Private",
      description: "Your information is secure and confidential"
    }
  ];

  const openQuiz = () => {
    window.open('https://www.wethebillions.com/quiz', '_blank');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-accent-light/30 to-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-12"
          >
            <h2 className="text-3xl lg:text-4xl font-playfair font-bold text-gray-900 mb-6">
              Not Sure Where to Start?
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Take our free assessment to discover your child's learning strengths and challenges.
            </p>
          </motion.div>

          {/* Benefits Grid */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12"
          >
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 + 0.3 }}
                className="card text-center"
              >
                <div className="w-12 h-12 bg-accent-magenta/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={benefit.icon} className="h-6 w-6 text-accent-magenta" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{benefit.title}</h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </motion.div>
            ))}
          </motion.div>

          {/* CTAs */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="space-y-4"
          >
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={openQuiz} className="btn-gold text-lg px-10 py-5">
                Take the FREE Quiz
              </button>
              <button onClick={scrollToContact} className="btn-secondary text-lg px-10 py-5">
                Book Consultation
              </button>
            </div>
            <p className="text-sm text-gray-500">
              ✓ No email required for quiz results • ✓ 100% confidential • ✓ Instant feedback
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default QuizCTASection;